import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../components/RecordStatus";
import { manageTaxComponentsAPI, manageTaxComponentsLabel, manageTaxComponentsStatic } from "./taxComponents.config";
import appStatic from "../../../../config/appStatic";

const { Text, Title } = Typography;

const DetailPRD1300 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const {monthList} = appStatic;

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${manageTaxComponentsAPI.ManageTaxComponents}/${state.key}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setIsLoading(false);

        setInputField([
          {
            name: manageTaxComponentsLabel.name,
            value: objDetail.name,
          },
          {
            name: manageTaxComponentsLabel.percentage,
            value: objDetail.percentage,
          },
          {
            name: manageTaxComponentsLabel.creditAccountType,
            value: objDetail?.creditAccountType?.value ? objDetail?.creditAccountType?.value : "-",
          },
          {
            name: manageTaxComponentsLabel.creditAccount,
            value: objDetail?.creditAccount?.name ? objDetail?.creditAccount?.name : "-",
          },
          {
            name: manageTaxComponentsLabel.startDate,
            value: objDetail?.startDate ? (`${objDetail?.startDate[2]} ${monthList[objDetail?.startDate[1] - 1]} ${objDetail?.startDate[0]}`)
            : "-",
          }
        ]);
        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };


  return (
    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={state.variant?manageTaxComponentsLabel.taxComponents: manageTaxComponentsLabel.detailTaxComponent}
        pageItems={state.variant?manageTaxComponentsStatic.viewTaxComponentBreadCrumbItems:manageTaxComponentsStatic.detailFxRateItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {manageTaxComponentsLabel.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input
                      disabled
                      value={item.value}
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </Card>
      
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailPRD1300);
